<adm-type-ahead-selector2
  label="Vælg lokation"
  [fetchFn]="fetchLocations"
  [fetchByIdFn]="fetchLocationById"
  [initialId]="initialId()?.toString()"
  (itemSelected)="locationSelected($event)"
  [itemTemplate]="itemTemplate() ? itemTemplate() : defItemTemplate"
  identityPropertyName="identifier"
  (clearTypeAhead)="clearTypeAhead.emit()"
  [placeholder]="placeholder()"
  [resetTrigger]="resetTrigger()"></adm-type-ahead-selector2>

<ng-template #defItemTemplate let-location>
  {{ location.name }}, {{ location.road }} {{ location.number }}{{ location.letter }}, {{ location.postalCode }}
  {{ location.city }}
</ng-template>
